import React from 'react';
import { motion } from 'framer-motion';
import { BoxIcon } from 'lucide-react';
interface Tab {
  id: string;
  label: string;
  icon: BoxIcon;
}
interface MobileNavProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (id: string) => void;
}
export function MobileNav({
  tabs,
  activeTab,
  onTabChange
}: MobileNavProps) {
  return <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 border-t" style={{
    backgroundColor: '#1e2d3d',
    borderColor: '#2a3d52'
  }} data-id="element-341">
      <div className="flex justify-around items-center px-2 py-2" data-id="element-342">
        {tabs.map(tab => {
        const Icon = tab.icon;
        const isActive = tab.id === activeTab;
        return <button key={tab.id} onClick={() => onTabChange(tab.id)} className="flex flex-col items-center justify-center p-2 rounded-xl w-full transition-colors" style={{
          color: isActive ? '#3b8fd4' : '#7fb3d3'
        }} data-id="element-343">
              <div className="relative p-1 rounded-lg" style={{
            backgroundColor: isActive ? 'rgba(59,143,212,0.15)' : 'transparent'
          }} data-id="element-344">
                <Icon className="w-5 h-5" data-id="element-345" />
              </div>
              <span className="text-[10px] font-medium mt-1 truncate max-w-[64px]" data-id="element-346">
                {tab.label}
              </span>
            </button>;
      })}
      </div>
    </div>;
}